export const getPrimaryImage = (p) => {
  if (Array.isArray(p.imageUrls) && p.imageUrls[0]) return p.imageUrls[0];
  if (typeof p.primaryImageUrl === "string" && p.primaryImageUrl) return p.primaryImageUrl;
  if (typeof p.imageUrl === "string" && p.imageUrl) return p.imageUrl;
  return "/images/pictureComingSoon.jpg";
};
